const features = [
  {
    icon: 'ri-movie-2-line',
    title: '全网资源聚合',
    desc: '奇优影院、97影院、窝窝影院、第九影院等热门站点一网打尽，热门影视资源一站式搜索，省去多个平台切换的麻烦。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清极速播放',
    desc: '全站采用高速CDN加速，支持1080P高清画质流畅播放，不卡顿、不缓冲，带来影院级别的在线观影体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '最新电影、热播电视剧、热门综艺第一时间同步上线，追剧不再等待，实时紧跟全网最热内容节奏。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-shield-star-line"></i>平台优势
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">为什么选择 51影院</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            专注影视资源聚合，打造一站式高清观影平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl p-6 md:p-8 hover:bg-background-200/70 transition-colors group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}